/**
 * Surface Thresholds Data (Heatmap Re-exports)
 *
 * Re-exports shared threshold data and resolvers from ThermalDesigner.
 * Keeps SafeMarginSection.tsx's import path unchanged.
 */

import {
  PANEL_THRESHOLDS_DATA,
  SUBSYSTEM_THRESHOLDS_DATA,
  getPanelThresholds,
  getSubsystemThresholds,
} from "../../../../../../../../src/components/Missions/Satellites/SatelliteProfile/SatelliteDesigner/ThermalDesigner/constants/surfaceThresholdsData";
import { DECK_TO_FACE_LABEL } from "../../../../../../../../src/components/Missions/Satellites/SatelliteProfile/SatelliteDesigner/ThermalDesigner/types/subsystems";
import type { FaceId } from "../hooks/ThermalHeatMapHooks";
import type { SubsystemDeck } from "../../../../../../../../src/components/Missions/Satellites/SatelliteProfile/SatelliteDesigner/ThermalDesigner/types/subsystems";

const FACE_ID_TO_PANEL_LABEL: Record<FaceId, string> = {
  PX: "+X",
  NX: "-X",
  PY: "+Y",
  NY: "-Y",
  PZ: "+Z",
  NZ: "-Z",
};

export { PANEL_THRESHOLDS_DATA, SUBSYSTEM_THRESHOLDS_DATA, getPanelThresholds, getSubsystemThresholds };

export const getFacePanelLabel = (face: FaceId): string => FACE_ID_TO_PANEL_LABEL[face];

export const getDeckPanelLabel = (deck: SubsystemDeck): string => DECK_TO_FACE_LABEL[deck];
